// src/components/Footer.js
import React from 'react';

const Footer = ({ fixed = false }) => (
  <footer className={`footer${fixed ? ' footer--fixed' : ''}`}>
    <p>&copy; 2024 ClevSheetsAI. All rights reserved.</p>
    <p>
      <a href="/privacy-policy" className="footer-link">
        Privacy Policy
      </a>
      |
      <a href="/terms-of-conditions" className="footer-link">
        Terms of Conditions
      </a>
    </p>
    <p>
      Icons by{' '}
      <a
        href="https://fontawesome.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="footer-link"
      >
        Font Awesome
      </a>
    </p>
    <p>
  ClevSheets AI — AI for Google Sheets | Automate spreadsheets | No formulas needed
</p>

  </footer>
);

export default Footer;
